import React from 'react';
import { getDeviceName } from "../../../../../../Utils";

const params = [ 'spends', 'conversions', 'eCost' ];

const Row = ({ country, device, days, daysData }) => {
    const daysTd = days.reduce((arr, day) => {
        params.forEach(param => arr.push(<td key={`${day}_${param}`}>{daysData[day][param]}</td>));

        return arr;
    }, []);

    return (
        <tr>
            <td>{country}</td>
            <td>{getDeviceName(device)}</td>
            {daysTd}
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/BidderECostCountry/components/DaysTable/components/Row/index.js